import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, Spinner } from 'react-bootstrap'
import { getAccessToken, setCompanyInfo } from '../helpers/helpers'
import { t } from '../locale'

interface Company {
    _id: string
    companyName: string
}

function CompanySelect() {
    const navigate = useNavigate()
    const [companies, setCompanies] = useState<Company[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const token = getAccessToken()
        if (!token) {
            navigate('/ds_id_verification/login')
            return
        }
        fetchCompanies(token)
    }, [navigate])

    async function fetchCompanies(token: string) {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/admin/companies`, {
            headers: { 'accessToken': token }
        })
        const data = await res.json()
        setCompanies(data.companies ?? [])
        setLoading(false)
    }

    async function selectCompany(company: Company) {
        const token = getAccessToken()
        if (!token) return
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/admin/impersonate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'accessToken': token },
            body: JSON.stringify({ companyId: company._id })
        })
        const data = await res.json()
        setCompanyInfo({
            companyId: company._id,
            companyName: company.companyName,
            impersonationToken: data.token
        })
        navigate('/ds_id_verification')
    }

    if (loading) {
        return (
            <div className='d-flex justify-content-center align-items-center mt-5'>
                <Spinner animation='border' variant='primary' />
            </div>
        )
    }

    return (
        <div className='container mt-5' style={{ maxWidth: 480 }}>
            <h4 className='mb-4 fw-bold text-primary'>{t('selectCompany')}</h4>
            <div className='d-flex flex-column gap-3'>
                {companies.map(company => (
                    <Card
                        key={company._id}
                        role='button'
                        className='shadow-sm'
                        onClick={() => selectCompany(company)}
                        style={{ cursor: 'pointer' }}
                    >
                        <Card.Body className='py-3 px-4'>
                            <span className='fw-semibold'>{company.companyName}</span>
                        </Card.Body>
                    </Card>
                ))}
            </div>
        </div>
    )
}

export default CompanySelect
